'use client';
import { SocialLinks } from '@/components/social-links';
import { staticData } from '@/static/content';
import classNames from 'classnames';
import Link from 'next/link';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { IBurgerMenuContent } from './burger-menu-content.types';

const DURATION = 300;

const defaultStyle = {
  transition: `opacity ${DURATION}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0, visibility: 'hidden' },
} as any;

export const BurgerMenuContent: IBurgerMenuContent = ({
  visible,
  socialLinks,
  close,
}) => {
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Transition nodeRef={nodeRef} in={visible} timeout={DURATION}>
      {(state) => (
        <div
          ref={nodeRef}
          style={{
            ...defaultStyle,
            ...transitionStyles[state as any],
          }}
          className={classNames(
            'h-screen fixed top-0 left-0 show-content bg-base-01 pt-[116px]',
            {
              'overflow-hidden': visible,
            }
          )}
        >
          <div
            className={classNames(
              'w-screen h-full flex flex-col justify-between p-[20px] pb-[60px]'
            )}
          >
            <nav className="flex flex-col gap-[32px]">
              {staticData.navigation.map(({ href, label }) => (
                <Link
                  key={href}
                  href={href}
                  onClick={close}
                  className="text-[16px] font-[800] cursor-pointer duration-200 hover:text-hover uppercase"
                >
                  {label}
                </Link>
              ))}
            </nav>

            <SocialLinks links={socialLinks} className="justify-center" />
          </div>
        </div>
      )}
    </Transition>
  );
};
